// generated by AI to bump up unit test coverage (https://coursera.atlassian.net/browse/MERCH-2272)
import * as React from 'react';

import * as Sentry from '@sentry/react';

import { useCampaignModulesData } from 'bundles/campaigns/context/CampaignModulesDataContext';
import type { PromoTemplateCollectionsFragment } from 'bundles/front-page/__generated__/contentfulTypes';
import SpotlightCollectionsModuleRenderer from 'bundles/front-page/redesign-modules/spotlight-collections/SpotlightCollectionsModuleRenderer';
import getNewReleasesSpotlightCollectionsData from 'bundles/front-page/utils/getNewReleasesSpotlightCollections';

type Props = {
  content?: PromoTemplateCollectionsFragment;
  isFirstSpotlightCollectionModule?: boolean;
  dataTestId?: string;
};

const SpotlightCollectionModuleDelegator = ({ content, isFirstSpotlightCollectionModule, dataTestId }: Props) => {
  const { campaignData, loading: isCampaignDataLoading } = useCampaignModulesData();
  const campaignContent = campaignData?.collectionsModule?.contentDataJson;
  const newReleasesSpotlightCollectionsData = getNewReleasesSpotlightCollectionsData();

  if (isCampaignDataLoading || !campaignContent) {
    return (
      <SpotlightCollectionsModuleRenderer
        {...(content ? { content } : newReleasesSpotlightCollectionsData)}
        dataTestId={dataTestId}
      />
    );
  }

  /**
   * because contentDataJson is an 'any' type it could possibly not contain the expected fields,
   * so we surround in a try/catch
   */
  try {
    if (isFirstSpotlightCollectionModule) {
      return <SpotlightCollectionsModuleRenderer content={campaignContent} dataTestId={dataTestId} />;
    } else {
      return (
        <SpotlightCollectionsModuleRenderer
          {...(content ? { content } : newReleasesSpotlightCollectionsData)}
          dataTestId={dataTestId}
        />
      );
    }
  } catch (e) {
    Sentry.captureMessage('Error rendering SpotlightCollectionModuleDelegator', {
      level: 'warning',
      extra: {
        message: e instanceof Error ? e.message : 'Unknown error',
        contentDataJson: JSON.stringify(campaignContent),
      },
    });
    return <SpotlightCollectionsModuleRenderer {...newReleasesSpotlightCollectionsData} dataTestId={dataTestId} />;
  }
};

export default SpotlightCollectionModuleDelegator;
